import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';

export const ShipmentItemsExpanderContent = () => {
  return <Text textType={TextType.Description} value={messages.shipmentItemsTablePlaceholder} />;
};
